export function numbers() {
  const numbers = document.querySelector('.js-numbers');
  if (!numbers) return;

  const counts = numbers.querySelectorAll('.js-count');

  const formatNumber = (num, format, digits) => {
    if (format === 'comma') {
      return Number(num).toLocaleString(undefined, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });
    }

    // plain（小数保持）
    return Number(num).toFixed(digits);
  };

  const animateCount = (el, from, to, duration = 1000) => {
    const start = performance.now();
    const format = el.dataset.format || 'plain';

    // 👇 小数点桁数を自動取得
    const decimalPart = (el.dataset.to.split('.')[1] || '');
    const digits = decimalPart.length;

    const update = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const value = from + (to - from) * progress;

      el.textContent = formatNumber(value, format, digits);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(to, format, digits);
      }
    };

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-visible')) {

        const from = parseFloat(entry.target.dataset.from);
        const to = parseFloat(entry.target.dataset.to);

        entry.target.classList.add('is-visible');

        animateCount(entry.target, from, to);

        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.5,
  });

  counts.forEach(target => observer.observe(target));
}